import React from 'react';
import Modal from '../shared/Modal';
import withSplashMessage from '../splashMessage/withSplashMessage';
import Spinner from '../shared/Spinner';
import ENV_CONFIG from '../../env';
import {
  maskServiceDate,
  maskServiceStartTime,
  maskServiceEndTime,
  maskMoney,
} from '../../masks';

class ServiceSendDetailsSms extends React.Component {
  state = {
    isSending: false,
  };

  render() {
    const { isSending } = this.state;
    const { additional_dates } = this.props.service;
    let saveBtnText = this.props.unsaved ? 'Save & Send SMS' : 'Send SMS';
    if (Array.isArray(additional_dates) && additional_dates.length > 0) {
      saveBtnText = 'Save & Send SMS to All'
    }

    if (!this.props.isOpen) return '';
    const text = this.buildSmsPreview();
    return (
      <Modal isOpen={this.props.isOpen} onRequestClose={this.props.closeModal}>
        <div className="admin-wrapper">
          <h2 className="h3 cms__section-head">Send SMS:</h2>
          <p className="p">
            Send the following text message to {this.props.staff.chef.name}?
          </p>
          <div
            className="p"
            style={{
              whiteSpace: 'pre-wrap',
              backgroundColor: '#eee',
              padding: '15px 20px',
              margin: '20px 0',
            }}
          >
            {text}
          </div>
          <div className="form__row">
            <div className="form__row-item--half">
              <div
                className="btn btn--hollow-red-bright btn--full-width"
                onClick={this.props.closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item--half">
              <button
                className="btn btn--solid-blue btn--full-width"
                onClick={this.onSubmit}
                disabled={this.state.isSending}
              >
                {saveBtnText}
              </button>
            </div>
          </div>
        </div>
        <Spinner isRequestOut={isSending}></Spinner>
      </Modal>
    );
  }

  onSubmit = () => {
    this.setState({ isSending: true });

    this.props.sendStaffSmsInvite(this.props.staff);
  };

  componentDidUpdate = (prevProps) => {
    // was modal just closed?
    if (!this.props.isOpen && prevProps.isOpen) {
      this.setState({ isSending: false });
    }
  };

  buildSmsPreview() {
    const { service, staff } = this.props;
    let text =
      `Hello ${staff.chef.first_name},\n` +
      `We have a client with whom we'd like to match you. Please take a look at the details below.\n\n` +
      `Client: ${service.client.name}\n` +
      `Date: ${maskServiceDate(service.start_time)}\n` +
      `Time: ${maskServiceStartTime(service.start_time)} - ${maskServiceEndTime(
        service.end_time
      )}\n` +
      `Location: ${service.address.zip_code}\n` +
      `Type: ${service.service_type}\n`;

    if (['weekly', 'custom_weekly'].includes(service.service_type)) {
      text += `Portion Size: ${service.portion_size}\n`;
    }

    if (service.service_type === 'occasion') {
      text += `Rate: ${maskMoney(
        parseInt(staff.rate, 10) + parseInt(staff.tip_cents, 10)
      )} (${maskMoney(staff.rate)} + ${maskMoney(staff.tip_cents)} Tip)\n`;
    } else {
      text += `Rate: ${maskMoney(
        parseInt(staff.rate, 10) + parseInt(service.tip_cents, 10)
      )} (${maskMoney(staff.rate)} + ${maskMoney(service.tip_cents)} Tip)\n`;
    }

    if (service.service_type === 'occasion') {
      text += `Guest Count: ${service.guest_number}\n`
    }
    if (service.number_of_meals > 1) {
      text += `Number of Meals: ${service.number_of_meals}\n`;
    } else {
      text += `Role: ${staff.role}\n\n`;
    }

    let accept_link = `${ENV_CONFIG.REACT_APP_SCHEMA}://${ENV_CONFIG.REACT_APP_APP_HOST}/chef-confirm-invite/accept/token`;
    text += `Click here to accept: ${accept_link}\n\n`;
    let decline_link = `${ENV_CONFIG.REACT_APP_SCHEMA}://${ENV_CONFIG.REACT_APP_APP_HOST}/chef-confirm-invite/reject/token`;
    text += `Click here to decline: ${decline_link}\n`;
    return text;
  }
}

export default withSplashMessage(ServiceSendDetailsSms);



// WEBPACK FOOTER //
// ./src/components/service/ServiceSendDetailsSms.js